import Vue from "vue";
import promise from "es6-promise";
promise.polyfill();
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/reset.css";
import "./styles/common.styl";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
// ===动态改变标题
import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);
// ===增添meta
import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);
/* 图片懒加载 */
// ****记住要引入assets里的图片要用require(),不仅在.vue文件的js部分要用require引入
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  error: require("@/assets/default.png"),
  loading: require("@/assets/default.png")
});
/* 无缝滚动 */
import scroll from "vue-seamless-scroll";
Vue.use(scroll);
if (process.env.VUE_APP_TITLE === "prod") {
  Vue.prototype.imgURL = "https://img.blackrockread.com";
  Vue.prototype.isShowA = false;
} else if (process.env.VUE_APP_TITLE === "test") {
  Vue.prototype.imgURL = "http://test.img.blackrockread.com";
  Vue.prototype.isShowA = true;
} else if (process.env.VUE_APP_TITLE === "uat") {
  Vue.prototype.imgURL = "http://uat.img.blackrockread.com";
  Vue.prototype.isShowA = true;
} else {
  Vue.prototype.imgURL = "http://test.img.blackrockread.com";
  Vue.prototype.isShowA = true;
}
/* 挂在全局组件 */
import comments from "@/components/components.js";
Vue.use(comments);

if (process.env.VUE_APP_TITLE === "prod") {
  Vue.prototype.pro = true;
} else {
  Vue.prototype.pro = false;
}
/* qs */
import qs from "qs";
Vue.prototype.qs = qs;
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App),
  /* //添加到这里,这里的render-event和vue.config.js里面的renderAfterDocumentEvent配置名称一致
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  } */
}).$mount("#app");
